import { Component } from "@angular/core";

@Component({
  selector: "wat-failed",
  template: `<p>Login failed. Please try again.</p>`,
  styleUrls: [],
  standalone: true
})
export class FailedLoginComponent {}
